import Base from './base'
import { sortBy } from '../utils'

export default {
  get (year, make) {
    return Base
      .get(`/year/${year}/make/${make}/models`)
      .then(res => res.data)
      .then(data => data.sort(sortBy('modelDescription')))
  }
}
